import { Component, OnDestroy } from '@angular/core';
import { IColsLogos, IColsObject, IFooter, IDisclaimer } from 'src/app/model/http/footer.model';
import { StrappiService } from 'src/app/services/strappi.service';
import { Subscription } from 'rxjs';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: `./footer.component${environment.templateSuffix}.html`,
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnDestroy {
  colLegales: IColsObject = {
    links: []
  };
  colAyuda: IColsObject = {
    links: []
  };
  colSocial: IColsObject = {
    links: []
  };
  colLogos: IColsLogos[] = [];
  footer: IFooter = {
    derechos: {
      title: ''
    }
  };
  logo: IColsLogos = {};
  dataAllDisclaimers: IDisclaimer[] = []
  dataDisclaimers: IDisclaimer[] = []
  fisrtColumnDisclaimers: IDisclaimer[] = []
  secondColumnDisclaimers: IDisclaimer[] = []

  screen!: number;
  obsScreen!: Subscription;
  obsState!: Subscription;

  derechos = '2022 BitCar Derechos Reservados';
  title = 'Esta página se construye con tecnología de BitCar México';

  constructor(
    private strappiService: StrappiService,
    private titleService: Title,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.strappiService.getDisclaimers().subscribe((resDisclaimers) => {
      this.dataAllDisclaimers = resDisclaimers.legal_disclaimer
      this.orderDataDisclaimers(this.dataAllDisclaimers.slice(0, 2));
    })

    this.matIconRegistry.addSvgIcon('icon-fb', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/v3/leasing-footer-redes-fb.svg"));
    this.matIconRegistry.addSvgIcon('icon-insta', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/v3/leasing-footer-redes-insta.svg"));
    this.matIconRegistry.addSvgIcon('icon-linkedin', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/v3/leasing-footer-redes-linkedin.svg"));
    this.matIconRegistry.addSvgIcon('icon-x', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/v3/leasing-footer-redes-x.svg"));
    this.matIconRegistry.addSvgIcon('icon-youtube', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/v3/leasing-footer-redes-youtube.svg"));

  }


  orderDataDisclaimers(data: any) {
    this.fisrtColumnDisclaimers = data.splice(0, 2);
    this.secondColumnDisclaimers = data.splice(0, data.length);

    this.dataDisclaimers = [...this.fisrtColumnDisclaimers, ...this.secondColumnDisclaimers];
  }

  ngOnDestroy(): void {
    this.obsScreen.unsubscribe();
    this.obsState.unsubscribe();
  }

  /**
   * Set the title of the page for SEO
   * @param {*} title
   * @memberof FooterComponent
   * @author victor.mendez
   */
  setTitle(title: any) {
    this.titleService.setTitle(`BitCar - ${title}`);
  }

}

